export const compatiblePhones = [
    {
        title: "Apple",
        phones: [
            "iphone 7",
            "iphone 7 plus",
            "iphone 8",
            "iphone 8 plus",
            "iphone X",
            "iphone XS",
            "iphone XS Max",
            "iphone XR",
            "iphone SE (2020)",
            "iphone 11",
            "iphone 11 pro",
            "iphone 12",
            "iphone 12 mini",
            "iphone 12 pro",
            "iphone 12 pro Max",
            "iphone 13",
            "iphone 13 mini",
            "iphone 13 pro",
            "iphone 13 pro Max",
            "iPhone 14",
            "iPhone 14 Plus",
            "iPhone 14 Pro",
            "iPhone 14 Pro Max",
            "iPhone 15",
            "iPhone 15 Plus",
            "iPhone 15 Pro",
            "iPhone 15 Pro Max",
            "iPhone 16",
            "iPhone 16 Pro",
        ]
    },
    {
        title: "Asus",
        phones: [
            "Zenfone 11 Ultra",
            "ROG Phone 8 Pro Edition",
            "ROG Phone 8 Pro",
            "ROG Phone 8",
            "Zenfone 10",
            "ROG Phone 7 Ultimate",
            "ROG Phone 7",
            "ROG Phone 6 Diablo Immortal Edition",
            "ROG Phone 6 BATMAN Edition",
            "ROG Phone 6D",
            "ROG Phone 6D Ultimate",
            "ROG Phone 6",
            "Zenfone 9",
            "Zenfone 8 Flip",
            "Zenfone 8",
            "ROG Phone 5 Ultimate",
            "ROG Phone 5s Pro",
            "ROG Phone 5s",
            "ROG Phone 5 Pro",
            "ROG Phone 5",
        ]
    },
    {
        title: "Cat",
        phones: [
            "S75",
            "S53",
            "S42 H+",
        ]
    },
    {
        title: "Essential",
        phones: [
            "Essential PH-1"
        ]
    },
    {
        title: "Fairphone",
        phones: [
            "Fairphone 5",
            "Fairphone 4"
        ]
    },
    {
        title: "Google",
        phones: [
            "Pixel",
            "Pixel XL",
            "Pixel 2",
            "Pixel 2XL",
            "Pixel 3XL",
            "Pixel 3",
            "Pixel 3A",
            "Nexus 4",
            "Pixel 4A",
            "LG Nexus 5",
            "Nexus 5X",
            "Nexus 6P",
            "Pixel 6",
            "Pixel 6 Pro",
            "Pixel 6a",
            "Pixel 7",
            "Pixel 7 Pro",
            "Pixel 7a",
            "Pixel Fold",
            "Pixel 8",
            "Pixel 8 Pro",
            "Pixel 8a",
            "Pixel 9",
            "Pixel 9 Pro Fold",
            "Pixel 9 Pro and Pro XL",
        ]
    },
    {
        title: "Honor",
        phones: [
            "Honor 8",
            "Honor View 20",
            "Honor V10",
            "Honor 8 Pro",
        ]
    },
    {
        title: "HTC",
        phones: [
            "One A9",
            "Desire 20 Plus",
            "U Ultra",
            "10 Evo",
            "U11 Plus",
            "Desire 10 Pro",
            "One E8",
            "Desire Eye",
            "10 Lifestyle",
            "One ME",
            "One E9 +",
            "One M9 Plus",
            "Desire 21 Pro 5G",
            "Desire 22 Pro",
            "U23 Pro",
            "U24 Pro",
        ]
    },
    {
        title: "LG",
        phones: [
            "LG G3",
            "LG G4",
            "LG G5",
            "LG Nexus 5X",
            "LG V10",
            "LG V20",
            "LG V30",
            "LG V30 ThinQ",
            "LG V35 ThinQ",
            "LG V40 ThinQ",
            "LG G6",
            "LG Q6",
            "LG Q6 Plus",
            "LG Q Styus",
            "LG Q Stylus 4",
            "LG Q7",
            "LG G7 ThinQ",
            "LG Q8",
            "LG G8 ThinQ",
            "LG Q92",
            "LG K10",
            "LG K62",
            "LG K92",
            "LG V35 ThinQ",
            "LG Wing",
            "LG G7 Plus ThinQ",
            "LG G4 Dual",
            "LG G2",
            "LG G2",
            "LG Stylus 2 Plus",
            "LG F70",
            "LG G Pro 2",
            "LG Q7 Plus",
        ]
    },
    {
        title: "Motorola",
        phones: [
            "Moto G75",
            "Edge 50 Neo",
            "Moto G55",
            "Moto G35",
            "Razr 50 Ultra",
            "Razr 50",
            "Moto G85",
            "Edge 50 Pro",
            "Edge 50 Fusion",
            "Edge 50 Ultra",
            "Moto G34",
            "Edge 40 Neo",
            "Moto G14",
            "Moto G84",
            "Moto G54",
            "Razr 40",
            "Razr 40 Ultra",
            "Moto G13",
            "Moto G23",
            "Moto G53",
            "Moto G73",
            "Edge 40",
            "Edge 40 Pro",
            "ThinkPhone",
            "Razr",
            "Moto G72",
            "Moto G32",
            "Edge 30 Neo",
            "Edge 30 Fusion",
            "Edge 30 Ultra",
            "Moto G62 5G",
            "Moto X30 Pro",
            "Moto G82 5G",
            "Moto G82",
            "Moto G22",
            "Edge 30",
            "Edge 30 Pro",
            "Moto G41",
            "Edge X30",
            "Moto G200 5G",
            "Moto G31",
            "Moto G71 5G",
            "Moto G51 5G",
            "Edge 20 Pro",
            "Edge 20 Fusion",
            "Edge 20",
            "Edge (2021)",
            "Moto G100",
            "Moto G60s",
            "Moto G60",
            "Moto G40 Fusion",
            "Moto G20",
            "Moto G50",
            "Moto G30",
            "Moto G100",
            "Edge S",
            "One 5G Ace",
        ]
    },
    {
        title: "Nokia",
        phones: [
            "Nokia 3",
            "Nokia 3.1",
            "Nokia 4.2",
            "Nokia 5",
            "Nokia 5.1",
            "Nokia 5.4",
            "Nokia 6",
            "Nokia 6.1",
            "Nokia 7",
            "Nokia 7 Plus",
            "Nokia 8 Sirocco",
            "Nokia 8",
            "Nokia 8.1",
            "Nokia 9",
            "Nokia Lumia 920",
            "Nokia Lumia 930",
            "Nokia X10",
            "Nokia X20",
            "Nokia XR20",
            "Nokia XR21",
            "Nokia X30 5G",
            "Nokia X100",
            "Nokia G11",
            "Nokia G20",
            "Nokia G21",
            "Nokia G22",
            "Nokia G42",
            "Nokia G50",
            "Nokia G60 5G",
            "Nokia G300",
        ]
    },
    {
        title: "One Plus",
        phones: [
            "OnePlus 3",
            "OnePlus 3T",
            "OnePlus 5",
            "OnePlus 5T",
            "OnePlus 6",
            "OnePlus 7",
            "OnePlus 7T",
            "OnePlus 7 Pro",
            "7T Pro McLaren Edition",
            "OnePlus 8 Pro",
            "OnePlus 8",
            "OnePlus Nord",
            "OnePlus 8T",
            "OnePlus 6T",
            "OnePlus 9",
            "OnePlus 9 Pro",
            "OnePlus 9 R",
        ]
    },
    {
        title: "OPPO",
        phones: [
            "OPPO Reno6",
            "OPPO Reno6 Pro",
            "OPPO Reno 4",
            "OPPO Reno 2",
            "OPPO Find X2",
            "OPPO R17 Pro",
            "OPPO Reno 3",
            "OPPO Find X3 Pro",
            "OPPO Reno 6 Pro Plus",
            "OPPO K9",
            "OPPO A95",
            "OPPO Find X3",
            "OPPO K9 Pro",
            "OPPO Reno 5 Pro",
            "OPPO Reno 10x",
            "OPPO N1",
            "OPPO Reno 5A",
            "OPPO Reno",
            "OPPO Reno6 4G",
            "OPPO A16s",
            "OPPO A94",
            "OPPO Find X3 Neo",
            "OPPO Reno 5 Lite",
            "OPPO Reno 3A",
            "OPPO N1 Mini",

        ]
    },
    {
        title: "Poco",
        phones: [
            "Poco F2 Pro",
            "Poco F3",
            "Poco X3 GT",
        ]
    },
    {
        title: "Realme",
        phones: [
            "GT",
            "Narzo 30",
            "X7 Max",
            "X7 Pro",
            "Narzo 30",
            "X50 Pro",
            "X7 Max",
            "X2 Pro",
            "GT Neo",
        ]
    },
    {
        title: "Samsung",
        phones: [
            "Galaxy SIII",
            "Galaxy S4",
            "Galaxy S5",
            "Galaxy S6",
            "Galaxy S6 Edge",
            "Galaxy S6 Edge+",
            "Galaxy S7",
            "Galaxy S7 Edge",
            "Galaxy S8",
            "Galaxy S8+",
            "Galaxy S9",
            "Galaxy S9+",
            "Galaxy S9 Plus",
            "Galaxy S10",
            "Galaxy S10 Plus",
            "Galaxy S21 Plus",
            "Galaxy S21 5G",
            "Galaxy S20 Plus",
            "Galaxy S20 Ultra",
            "Galaxy S21 Ultra",
            "Galaxy S21 Ultra 5G",
            "Galaxy S22 Ultra 5G",
            "Galaxy S23 Ultra",
            "Galaxy S24 Ultra",
            "Galaxy S23",
            "Galaxy S23+",
            "Galaxy S24",
            "Galaxy S24+",
            "Galaxy S22 5G",
            "Galaxy S22+ 5G",
            "Galaxy S20 FE",
            "Galaxy S21 FE 5G",
            "Galaxy Note 3",
            "Galaxy Note 3 NEO",
            "Note 5",
            "Galaxy Note 5",
            "Galaxy Note 10 Lite",
            "Galaxy Note 10 Plus",
            "Galaxy Alpha",
            "Galaxy A14",
            "Galaxy A25",
            "Galaxy A32",
            "Galaxy A34",
            "Galaxy A35",
            "Galaxy A30s",
            "Galaxy A5",
            "Galaxy A15",
            "Galaxy A50s",
            "Galaxy A05s",
            "Galaxy A51",
            "Galaxy A52s",
            "Galaxy A52",
            "Galaxy A52 5G",
            "Galaxy A52s 5G",
            "Galaxy A53 5G",
            "Galaxy A54",
            "Galaxy A55",
            "Galaxy A70",
            "Galaxy A70s",
            "Galaxy A72",
            "Galaxy A80",
            "Galaxy A13 5G",
            "Galaxy A23 5G",
            "Galaxy A33 5G",
            "Galaxy A04s",
            "Galaxy M13",
            "Galaxy M23 5G",
            "Galaxy M33 5G",
            "Galaxy M53 5G",
            "Galaxy M32",
            "Galaxy M40",
            "Galaxy M42",
            "Galaxy A50s 6GB RAM",
            "Galaxy M51",
            "Galaxy M52 5G",
            "Galaxy M62",
            "Galaxy F62",
            "Galaxy On8",
            "Galaxy S3 Neo",
            "Galaxy Z Flip 3",
            "Galaxy Z Flip 3 5G",
            "Galaxy Z Fold 3",
            "Galaxy Z Flip 4",
            "Galaxy Z Fold 4",
            "Galaxy Z Flip 5",
            "Galaxy Z Fold 5",
            "Galaxy Z Flip 6",
            "Galaxy Z Fold 6",
            "Galaxy Quantum 2",
        ]
    },
    {
        title: "Sony",
        phones: [
            "XA1 / Ultra / Plus",
            "XA2 / Ultra / Plus",
            "XZ1 / Compact",
            "XZ2 / Compact / Premium",
            "Xperia 10",
            "Xperia 10 Lite",
            "Xperia 8 Lite",
            "Xperia XA1",
            "Xperia Z1",
            "Xperia C5",
            "Xperia XZ1",
            "Xperia XA1 Dual",
            "Xperia XA1 Ultra",
            "Xperia XZ",
            "Xperia T3",
            "Xperia XA",
            "Xperia ZR",
            "Xperia Z3 +",
            "Xperia SP",
            "Xperia XA1 Plus",
            "Xperia Z2",
            "Xperia Z5",
            "Xperia T2",
            "Xperia E3",
            "Xperia Z3",
            "Xperia L2",
            "Xperia M2",
            "Xperia Pro",
            "Xperia 1 VI",
            "Xperia 10 VI",
            "Xperia 5 V",
            "Xperia 10 V",
            "Xperia 1 V",
            "Xperia 5 IV",
            "Xperia 10 IV",
            "Xperia 1 IV",
            "Xperia Pro - I",
            "Xperia 5 III",
            "Xperia 1 III",
            "Xperia 10 III",
            "Xperia 10 III Lite",
            "Xperia Pro",
        ]
    },
    {
        title: "Vivo",
        phones: [
            "Vivo X70 Pro Plus",
            "Vivo X70 Pro",
            "Vivo X70",
            "Vivo Z6",
            "Vivo S10 Pro",
            "Vivo Nex 3S",
            "Vivo S9 5G",
            "Vivo X60T Pro Plus",
            "Vivo X60T",
            "Vivo Y53s",
        ]
    },    
    {
        title: "Xiaomi",
        phones: [
            "Mi 11X",
            "Mi 11 Lite",
            "Mi 10T Pro",
            "Mi 10",
            "Mi 10T",
            "Mi 11X",
            "Mi 11X Lite",
            "Mi3",
            "Redmi Note 10 Pro",
            "Redmi K40",
            "Mi Mix 4",
            "Mi 11T Pro",
            "Mi 11 Pro",
            "Redmi Note 9 Pro",
            "Redmi K40 Pro",
            "Mi 11 Ultra",
            "Mi 11 Lite NE",
            "Mi 11",
            "Mi5",
            "Mi 10T Lite",
            "Redmi K30s",
            "Mi 11i",
            "Redmi Note 9T",
            "Mi 10 Lite",
            "Redmi K40 Pro Plus",
            "Mi 10S",
            "Mi Mix Fold",
            "Redmi K30 Ultra",
            "Mi 10 Ultra",
            "Mi 11 Lite",
            "Mi 11 T",
        ]
    },
];
